import { render, staticRenderFns } from "./Matrix.vue?vue&type=template&id=728ba79b&scoped=true"
import script from "./Matrix.vue?vue&type=script&lang=js"
export * from "./Matrix.vue?vue&type=script&lang=js"
import style0 from "./Matrix.vue?vue&type=style&index=0&id=728ba79b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728ba79b",
  null
  
)

export default component.exports